webpackJsonp([1],{

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_PointTool__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_PolylineTool__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_DistanceTool__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools_PenTool__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_PenFillTool__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools_RectTool__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_PolygonTool__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tools_CircleTool__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tools_EllipseTool__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tools_MilitaryArrowTool__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tools_TextTool__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marker_PathMarker__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layer_FeatureLayer__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_geoUtils__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_meature_leaflet_measure_path__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_meature_leaflet_measure_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__plugins_meature_leaflet_measure_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_meature_leaflet_measure_path_css__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_meature_leaflet_measure_path_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__plugins_meature_leaflet_measure_path_css__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */














//
// 涉及重写Polyline 的 onAdd 和 flow 有顺序执行的冲突


//
var _T = T,
    isArray = _T.isArray;
var _L = L,
    Marker = _L.Marker,
    Polyline = _L.Polyline,
    Polygon = _L.Polygon,
    Circle = _L.Circle,
    CircleMarker = _L.CircleMarker;
/**
 * 标绘工具-管理器
 */

var DrawLayer = function (_FeatureLayer) {
  _inherits(DrawLayer, _FeatureLayer);

  function DrawLayer() {
    var _temp, _this, _ret;

    _classCallCheck(this, DrawLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _FeatureLayer.call.apply(_FeatureLayer, [this].concat(args))), _this), _this.history = [], _this.next = [], _this.options = { editable: true, draggable: true
      /**
       * 
       * @param dmap 
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * 用于回滚
   */

  /**
   * 用于前进
   */

  /**
   * 当前的绘制编辑对象
   */

  /**
   * 当前的绘制工具对象
   */

  /**
   * 当前的绘制工具类
   */

  /**
   * 默认配置选项
   */


  DrawLayer.prototype.addTo = function addTo(dmap) {
    dmap.on('draw-end', this.onDrawEnd.bind(this));
    return _FeatureLayer.prototype.addTo.call(this, dmap);
  };
  /**
   * 
   * @param {*} marker 
   * @param {*} options 
   * @param {*} data 
   */


  DrawLayer.prototype.add = function add(marker, options, data) {
    //
    if (options.tooltip) {
      options.tooltip.draggable = true;
    }
    _FeatureLayer.prototype.add.call(this, marker, options, data);
    // 设置为可编辑
    marker.editEnable();
    //
    marker.makeDraggable();
    marker.dragging.enable();
    //
  };

  /**
   * 改变地图工具
   * @param options {tool,feature,tooltip,popup}
   */


  DrawLayer.prototype.change = function change(options) {
    var that = this;
    if (options) {
      var dmap = that.dmap,
          history = that.history,
          next = that.next;

      switch (options.tool) {
        case 'clear':
          that.clear();
          break;
        case 'pointer':
          that.reset();
          break;
        case 'go':
          // 前进
          var todo = next[next.length - 1];
          if (todo && todo.restore()) {
            next.pop();
          }
          !history.includes(todo) && history.push(todo);
          that.reset();
          break;
        case 'back':
          // 回滚
          var done = history[history.length - 1];
          if (done && done.reback()) {
            history.pop();
          }
          !next.includes(done) && next.push(done);
          that.reset();
          break;
        default:
          that.start(options);
          break;
      }
      dmap.do('tool-change', { target: that, options: options });
    }
    return that;
  };
  /**
   * 启动绘制
   * @param options {tool:'',feature,tooltip,popup}
   */


  DrawLayer.prototype.start = function start(options) {
    var that = this;
    var map = that.map;

    var tool = options.tool;
    that.cancel();
    map.dragging.disable();
    (tool = that.get(tool)) && (tool = tool.create(that, options));
    if (tool) {
      var mergeOptions = T.assign({}, that.options, options);
      tool.options.feature.draggable = mergeOptions.draggable;
      tool.options.reable = mergeOptions.reable;
      tool.options.editable = mergeOptions.editable;
      tool.start();
    }
    that.tool = tool;
  };

  /**
   * 获取绘制工具
   * @param tool 
   */


  DrawLayer.prototype.get = function get(tool) {
    switch (tool) {
      case 'point':
        return __WEBPACK_IMPORTED_MODULE_0__tools_PointTool__["a" /* default */];
      case 'distance':
        return __WEBPACK_IMPORTED_MODULE_2__tools_DistanceTool__["a" /* default */];
      case 'polyline':
        return __WEBPACK_IMPORTED_MODULE_1__tools_PolylineTool__["a" /* default */];
      case "pen":
        return __WEBPACK_IMPORTED_MODULE_3__tools_PenTool__["a" /* default */];
      case "circle":
        return __WEBPACK_IMPORTED_MODULE_7__tools_CircleTool__["a" /* default */];
      case 'ellipse':
        return __WEBPACK_IMPORTED_MODULE_8__tools_EllipseTool__["a" /* default */];
      case "rect":
        return __WEBPACK_IMPORTED_MODULE_5__tools_RectTool__["a" /* default */];
      case "polygon":
        return __WEBPACK_IMPORTED_MODULE_6__tools_PolygonTool__["a" /* default */];
      case 'penfill':
        return __WEBPACK_IMPORTED_MODULE_4__tools_PenFillTool__["a" /* default */];
      case 'militaryArrow':
        return __WEBPACK_IMPORTED_MODULE_9__tools_MilitaryArrowTool__["a" /* default */];
      case 'text':
        return __WEBPACK_IMPORTED_MODULE_10__tools_TextTool__["a" /* default */];
    }
  };
  /**
   * 
   */


  DrawLayer.prototype.cancel = function cancel() {
    this.tool && this.tool.cancel();
    this.tool = null;
  };
  /**
   * 重置
   */


  DrawLayer.prototype.reset = function reset() {
    this.cancel();
    this.map.dragging.enable();
    //  map.doubleClickZoom.enable();
  };
  /**
   * 绘制结束
   */


  DrawLayer.prototype.onDrawEnd = function onDrawEnd(e) {
    // 重置前进内容
    this.next.length = 0;
    //
    var tool = this.tool;

    if (tool) {
      // 推进历史
      !this.history.includes(tool) && this.history.push(tool);
      //
      var _tool = tool,
          options = _tool.options,
          marker = _tool.marker;

      if (options.searchable) {
        this.dmap.do('search-end', { target: this, event: e, value: this.search(e) });
      }
      // 设置为可编辑
      if (options.editable) {
        T.defer(function () {
          marker.editEnable();
        });
      }
      //
      options.onDrawEnd && options.onDrawEnd(e);
      // 绘制模式
      if (options.multi) {
        // 重复绘制
        tool.cancel();
        tool = this.tool = tool.clone();
        tool.start();
      } else if (options.reable) {
        // 重新绘制
        tool.cancel();
        this.tool = tool;
        tool.start();
      } else {
        // 重置
        this.reset();
      }
    } else {
      this.reset();
    }
  };
  /**
   * 搜索
   */


  DrawLayer.prototype.search = function search(e) {
    var marker = e.marker,
        result = [];

    if (!marker) {
      throw 'search error';
    }
    var map = marker._map;

    if (marker instanceof Circle) {
      var _radius = marker._radius;

      var center = marker.getLatLng();
      map.eachLayer(function (layer) {
        //
        if (layer instanceof Marker || layer instanceof __WEBPACK_IMPORTED_MODULE_11__marker_PathMarker__["a" /* default */]) {
          if (map.latLngToLayerPoint(layer.getLatLng()).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
            result.push(layer);
          }
        } else if (layer instanceof Polyline) {
          var latlngs = layer.getLatLngs();
          if (isArray(latlngs[0])) {
            //todo 
            latlngs = latlngs[0];
          }
          for (var i = 0, len = latlngs.length; i < len; i++) {
            if (map.latLngToLayerPoint(latlngs[i]).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
              result.push(layer);
              break;
            }
          }
        } else if (layer instanceof Polygon) {
          var _latlngs = layer.getLatLngs();
          if (isArray(_latlngs[0])) {
            _latlngs = _latlngs[0];
          }
          for (var _i = 0, _len2 = _latlngs.length; _i < _len2; _i++) {
            if (map.latLngToLayerPoint(_latlngs[_i]).distanceTo(map.latLngToLayerPoint(center)) < _radius) {
              result.push(layer);
              break;
            }
          }
        }
      });
    } else if (marker instanceof Polygon) {
      var _rings = marker._rings;

      map.eachLayer(function (layer) {
        if (layer instanceof Marker || layer instanceof CircleMarker) {
          if (Object(__WEBPACK_IMPORTED_MODULE_13__utils_geoUtils__["a" /* pointInPolygon */])(map.latLngToLayerPoint(layer.getLatLng()), _rings[0])) {
            result.push(layer);
          }
        } else if (layer instanceof Polyline) {
          var latlngs = layer.getLatLngs();
          if (isArray(latlngs[0])) {
            //todo 
            latlngs = latlngs[0];
          }
          for (var i = 0, len = latlngs.length; i < len; i++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_13__utils_geoUtils__["a" /* pointInPolygon */])(map.latLngToLayerPoint(latlngs[i]), _rings[0])) {
              result.push(layer);
              break;
            }
          }
        } else if (layer instanceof Polygon) {
          var _latlngs2 = layer.getLatLngs();
          if (isArray(_latlngs2[0])) {
            _latlngs2 = _latlngs2[0];
          }
          for (var _i2 = 0, _len3 = _latlngs2.length; _i2 < _len3; _i2++) {
            if (Object(__WEBPACK_IMPORTED_MODULE_13__utils_geoUtils__["a" /* pointInPolygon */])(map.latLngToLayerPoint(_latlngs2[_i2]), _rings[0])) {
              result.push(layer);
              break;
            }
          }
        }
      });
    }
    return result;
  };

  return DrawLayer;
}(__WEBPACK_IMPORTED_MODULE_12__layer_FeatureLayer__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (DrawLayer);

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
/**
 *  @param {boolean} restart 重新启动
 */
var Tool = function () {
  function Tool() {
    _classCallCheck(this, Tool);
  }

  /**
   * 
   * @param options 
   */
  Tool.prototype.setOptions = function setOptions(options) {
    T.assign(this.options, options);
  };
  /**
   * 
   */


  Tool.prototype.reback = function reback() {
    var marker = this.marker,
        layer = this.layer,
        history = this.history;

    if (marker) {
      if (marker._defaultShape) {
        //线/面
        var latlngs = marker._defaultShape();
        var latlng = latlngs.pop();
        if (latlng) {
          history.push(latlng);
          marker.setLatLngs(latlngs);
        } else {
          marker.removeFrom(layer);
          return true;
        }
      } else {
        marker.removeFrom(layer);
        return true;
      }
    }
  };
  /**
   * 
   */


  Tool.prototype.restore = function restore() {
    var marker = this.marker,
        layer = this.layer,
        history = this.history;

    if (marker) {
      marker.addTo(layer);
      //
      if (marker._defaultShape && history.length > 0) {
        //线/面
        var latlngs = marker._defaultShape();
        var latlng = history.pop();
        latlngs.push(latlng);
        marker.setLatLngs(latlngs);
      } else {
        return true;
      }
    }
  };
  /**
   * 绘制结束
   * @param e 
   */


  Tool.prototype.onEnd = function onEnd(e) {
    //
    this.history = [];
    //
    this.dmap.do('draw-end', { target: this, marker: this.marker });
  };
  /**
   * 清除图元，用于重置工具，重复绘制，或者取消绘制
   */


  Tool.prototype.clear = function clear() {
    var marker = this.marker;

    marker && marker.remove();
  };
  /**
   * 重置
   */


  Tool.prototype.reset = function reset() {
    if (this.restart) {
      this.clear();
      this.restart = false;
      this.marker = null;
    }
  };
  /**
   * 
   */


  Tool.prototype.cancel = function cancel() {};
  /**
   * 创建
   * @param control 
   */


  Tool.create = function create(owner, options) {
    var tool = new this();
    tool.owner = owner;
    tool.dmap = owner.dmap;
    tool.map = owner.map;
    tool.layer = owner.layer;
    tool.setOptions(options);
    return tool;
  };
  /**
   * 复制工具
   */


  Tool.prototype.clone = function clone() {
    return this.constructor.create(this.owner, this.options);
  };

  return Tool;
}();

/* harmony default export */ __webpack_exports__["a"] = (Tool);

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_PathMarker__ = __webpack_require__(22);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.7.7
 */


//
/**
 * 点图元绘制工具
 */

var PointTool = function (_Tool) {
  _inherits(PointTool, _Tool);

  function PointTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, PointTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { src: 'circle', color: '#000', radius: 5, fillColor: '#FFF', weight: 1, fillOpacity: 1 }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PointTool.prototype.start = function start() {
    //
    this.onMouseDown = this.onMouseDown.bind(this);
    //
    // this.map.once('mousedown', this.onMouseDown);
    // this.map.once('mouseup', this.onEnd);
    //
    this.map.on('mousedown', this.onMouseDown);
  };
  /**
   * 取消
   */


  PointTool.prototype.cancel = function cancel() {
    this.map.off('mousedown', this.onMouseDown);
  };
  /**
   * 绘制-start
   * @param e 
   */


  PointTool.prototype.onMouseDown = function onMouseDown(e) {
    var latlng = e.latlng;
    var options = this.options,
        layer = this.layer,
        marker = this.marker;

    if (marker) {
      marker.setLatLng(latlng);
    } else {
      this.marker = new __WEBPACK_IMPORTED_MODULE_1__marker_PathMarker__["a" /* default */](latlng, options.feature).addTo(layer);
    }
    this.onEnd();
  };

  return PointTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PointTool);

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */

//
var _L = L,
    Polyline = _L.Polyline;
/**
 * 线绘制工具
 */

var PolylineTool = function (_Tool) {
  _inherits(PolylineTool, _Tool);

  function PolylineTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, PolylineTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', weight: 2 }

      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PolylineTool.prototype.start = function start() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    var map = this.map;

    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;
  };
  /**
   * 取消
   */


  PolylineTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null;
  };
  /**
   * 绘制
   */


  PolylineTool.prototype.onMouseDown = function onMouseDown(e) {
    this.reset();
    //
    var marker = this.marker,
        map = this.map,
        layer = this.layer,
        options = this.options;
    var latlng = e.latlng;
    //

    if (!marker) {
      marker = this.marker = new Polyline([latlng], options.feature).addTo(layer);
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this));
    } else {
      this.mp = null;
    }
  };
  /**
   * 
   * @param e 
   */


  PolylineTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker,
        mp = this.mp;
    var latlng = e.latlng;

    if (!mp) {
      //
      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      marker.getBounds().extend(mp);
      marker.redraw();
    }
  };

  return PolylineTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PolylineTool);

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_Circle__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */


// let { Circle } = L;
/**
 * 圆形绘制工具
 */

var CircleTool = function (_Tool) {
  _inherits(CircleTool, _Tool);

  function CircleTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, CircleTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', fillOpacity: .5, weight: 1 }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CircleTool.prototype.start = function start() {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    var map = this.map;

    map.once('mousedown', this.onMouseDown);
  };
  /**
   * 取消
   */


  CircleTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
  };
  /**
   * 
   * @param e 
   */


  CircleTool.prototype.onMouseDown = function onMouseDown(e) {
    var options = this.options;
    var map = this.map,
        layer = this.layer;
    var latlng = e.latlng;

    this.clear(); //重复绘制，先移除旧图元
    //
    this.marker = new __WEBPACK_IMPORTED_MODULE_1__marker_Circle__["a" /* default */](latlng, options.feature).addTo(layer);
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  };
  /**
   * 
   * @param e 
   */


  CircleTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker;

    var latlng = e.latlng;
    var center = marker.getLatLng();
    var r = latlng.distanceTo(center);
    marker.setRadius(r);
    marker.redraw();
  };

  return CircleTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CircleTool);

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PolylineTool__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */

//
var _L = L,
    Polyline = _L.Polyline;
/**
 * 线绘制工具
 */

var DistanceTool = function (_PolylineTool) {
  _inherits(DistanceTool, _PolylineTool);

  function DistanceTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, DistanceTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PolylineTool.call.apply(_PolylineTool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', weight: 2, showMeasurements: true, draggable: false }
      /**
       * 
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DistanceTool.prototype.onMouseMove = function onMouseMove(e) {
    _PolylineTool.prototype.onMouseMove.call(this, e);
    this.marker.updateMeasurements();
  };

  return DistanceTool;
}(__WEBPACK_IMPORTED_MODULE_0__PolylineTool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DistanceTool);

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.1.4
 */

//
var _L = L,
    Polyline = _L.Polyline;
/**
 * 铅笔工具
 */

var PenTool = function (_Tool) {
  _inherits(PenTool, _Tool);

  function PenTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, PenTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red' }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PenTool.prototype.start = function start() {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.map.once('mousedown', this.onMouseDown);
    //
    this.restart = true;
  };
  /**
   * 取消
   */


  PenTool.prototype.cancel = function cancel() {
    this.map.off('mousedown', this.onMouseDown);
    this.map.off('mousemove', this.onMouseMove);
  };
  /**
   * 绘制-start
   * @param e 
   */


  PenTool.prototype.onMouseDown = function onMouseDown(e) {
    this.reset();
    //
    var marker = this.marker,
        options = this.options,
        map = this.map,
        layer = this.layer;
    var latlng = e.latlng;
    //

    if (!marker) {
      marker = this.marker = new Polyline([latlng], options.feature).addTo(layer);
      map.once('mouseup', this.onEnd.bind(this));
      map.on('mousemove', this.onMouseMove);
    }
  };
  /**
   * 绘制ing
   * @param e 
   */


  PenTool.prototype.onMouseMove = function onMouseMove(e) {
    this.marker.addLatLng(e.latlng);
  };

  return PenTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PenTool);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */

//

var PenFillTool = function (_Tool) {
  _inherits(PenFillTool, _Tool);

  function PenFillTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, PenFillTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', fillOpacity: .5, weight: 1 }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PenFillTool.prototype.start = function start() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    var map = this.map;

    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;
  };
  /**
   * 取消
   */


  PenFillTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
  };
  /**
   * 绘制
   */


  PenFillTool.prototype.onMouseDown = function onMouseDown(e) {
    this.reset();
    //
    var marker = this.marker,
        options = this.options,
        map = this.map,
        layer = this.layer;
    var latlng = e.latlng;
    //

    if (!marker) {
      marker = this.marker = L.rectangle(L.latLngBounds(latlng, latlng), options.feature).addTo(layer);
      map.on('mousemove', this.onMouseMove);
      map.once('mouseup', this.onEnd.bind(this));
      // map.off('mousedown', this.onMouseDown);
    }
  };
  /**
   * 
   * @param e 
   */


  PenFillTool.prototype.onMouseMove = function onMouseMove(e) {
    this.marker.addLatLng(e.latlng);
  };

  return PenFillTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PenFillTool);

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */

//
var _L = L,
    Rectangle = _L.Rectangle;
/**
 * 矩形绘制工具
 */

var RectTool = function (_Tool) {
  _inherits(RectTool, _Tool);

  function RectTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, RectTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', fillOpacity: .5, weight: 1 }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RectTool.prototype.start = function start() {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    var map = this.map;

    map.once('mousedown', this.onMouseDown);
  };
  /**
   * 取消
   */


  RectTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.sp = null;
  };
  /**
   * 绘制
   * @param e 
   */


  RectTool.prototype.onMouseDown = function onMouseDown(e) {
    var map = this.map,
        layer = this.layer,
        options = this.options;
    var latlng = e.latlng;

    this.clear(); //重复绘制，先移除旧图元
    //
    this.marker = new Rectangle(L.latLngBounds(latlng, latlng), options.feature).addTo(layer);
    this.sp = latlng;
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  };
  /**
   * 
   * @param e 
   */


  RectTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker;
    var latlng = e.latlng;

    marker.setBounds(L.latLngBounds(this.sp, latlng));
    marker.redraw();
  };

  return RectTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RectTool);

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.1.4
 */

//
var _L = L,
    Polygon = _L.Polygon;
/**
 * 多边形绘制工具
 */

var PolygonTool = function (_Tool) {
  _inherits(PolygonTool, _Tool);

  function PolygonTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, PolygonTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { color: 'red', fillOpacity: .5, weight: 1 }
      /**
       * 
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // move point


  PolygonTool.prototype.start = function start() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    //
    var map = this.map;

    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;
  };
  /**
   * 
   */


  PolygonTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null;
  };
  /**
   * 
   */


  PolygonTool.prototype.onMouseDown = function onMouseDown(e) {
    this.reset();
    //
    var marker = this.marker,
        map = this.map,
        layer = this.layer,
        options = this.options;
    var latlng = e.latlng;

    if (!marker) {
      marker = this.marker = new Polygon([latlng], options.feature).addTo(layer);
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this));
    }
    this.mp = null;
  };
  /**
   * 
   */


  PolygonTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker,
        mp = this.mp;
    var latlng = e.latlng;

    if (!mp) {
      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      marker.getBounds().extend(mp);
      marker.redraw();
    }
  };

  return PolygonTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PolygonTool);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.15
 */
var _L = L,
    Circle = _L.Circle;
/**
 * 
 */

/* harmony default export */ __webpack_exports__["a"] = (Circle.extend({
  /**
   * 原L.Circle在非经纬度等间隔投影的情况下是椭圆
   * 确保是圆形，用于标绘，但实际上是推荐的，因为半径已经不算是实际的半径
   */
  _updateBounds: function _updateBounds() {
    this._radius = this._radiusY;
    Circle.prototype._updateBounds.call(this);
  }
}));
/**
 * 
 */
Circle.include({
  /**
   * 
   */
  toGeoJSON: function toGeoJSON() {
    var _getLatLng = this.getLatLng(),
        lat = _getLatLng.lat,
        lng = _getLatLng.lng;

    this.options.radius = this._mRadius;
    return {
      type: 'Feature',
      properties: {},
      geometry: { coordinates: [lng, lat], type: 'Circle' }
    };
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircleTool__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_Ellipse__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */



/**
 * 椭圆绘制工具
 */

var EllipseTool = function (_CircleTool) {
  _inherits(EllipseTool, _CircleTool);

  function EllipseTool() {
    _classCallCheck(this, EllipseTool);

    return _possibleConstructorReturn(this, _CircleTool.apply(this, arguments));
  }

  /**
   * 
   * @param e 
   */
  EllipseTool.prototype.onMouseDown = function onMouseDown(e) {
    var options = this.options;
    var map = this.map,
        layer = this.layer;
    var latlng = e.latlng;

    this.clear(); //重复绘制，先移除旧图元
    //
    this.marker = new __WEBPACK_IMPORTED_MODULE_1__marker_Ellipse__["a" /* default */](latlng, 0, options.feature).addTo(layer);
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  };

  /**
   * 
   * @param e 
   */


  EllipseTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker;

    var latlng = e.latlng;
    var center = marker.getLatLng();
    var latlng1 = latlng.clone();
    var latlng2 = latlng.clone();
    latlng1.lat = center.lat;
    latlng2.lng = center.lng;
    var r = latlng1.distanceTo(center);
    var ry = latlng2.distanceTo(center);
    //
    marker.setRadius(r);
    marker.setRadiusY(ry);
    marker.redraw();
  };

  return EllipseTool;
}(__WEBPACK_IMPORTED_MODULE_0__CircleTool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EllipseTool);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tool__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_MilitaryArrow__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */


//
var _L = L,
    LatLng = _L.LatLng;
/**
 * 军标箭头
 */

var MilitaryArrowTool = function (_Tool) {
  _inherits(MilitaryArrowTool, _Tool);

  function MilitaryArrowTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, MilitaryArrowTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Tool.call.apply(_Tool, [this].concat(args))), _this), _this.options = { feature: { fillColor: 'red', weight: 1, fillOpacity: .5, color: '#333' }
      /**
       * 启动
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MilitaryArrowTool.prototype.start = function start() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    var map = this.map;

    map.on('mousedown', this.onMouseDown);
    this.restart = true;
  };
  /**
   * 取消
   */


  MilitaryArrowTool.prototype.cancel = function cancel() {
    var map = this.map;

    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null;
  };
  /**
   * 绘制
   */


  MilitaryArrowTool.prototype.onMouseDown = function onMouseDown(e) {
    this.reset();
    //
    var marker = this.marker,
        map = this.map,
        layer = this.layer,
        options = this.options;
    var feature = options.feature;
    var latlng = e.latlng;
    //

    if (!marker) {
      feature.draggable = false;
      // feature.interactive = false;
      marker = this.marker = new __WEBPACK_IMPORTED_MODULE_1__marker_MilitaryArrow__["a" /* default */]([latlng], feature).addTo(layer);
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this));
    } else {
      this.mp = null;
    }
    this.lp = e.layerPoint;
  };
  /**
   * 
   * @param e 
   */


  MilitaryArrowTool.prototype.onMouseMove = function onMouseMove(e) {
    var marker = this.marker,
        mp = this.mp,
        latlng = e.latlng,
        layerPoint = e.layerPoint,
        latlngs = marker.getLatLngs();

    if (!mp) {
      var lp = this.lp;

      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      // marker.getBounds().extend(mp)
      marker.redraw();
    }
  };

  return MilitaryArrowTool;
}(__WEBPACK_IMPORTED_MODULE_0__Tool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MilitaryArrowTool);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointTool__ = __webpack_require__(150);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.7.7
 */


//
/**
 * 点图元绘制工具
 */

var TextTool = function (_PointTool) {
  _inherits(TextTool, _PointTool);

  function TextTool() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextTool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PointTool.call.apply(_PointTool, [this].concat(args))), _this), _this.options = { feature: {}
      /**
       * 绘制-start
       * @param e 
       */
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextTool.prototype.onMouseDown = function onMouseDown(e) {
    var latlng = e.latlng;
    var options = this.options,
        layer = this.layer;
    //

    this.marker = L.text(latlng, options.text, options.feature).addTo(layer);
    this.onEnd();
  };

  return TextTool;
}(__WEBPACK_IMPORTED_MODULE_0__PointTool__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TextTool);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pointInPolygon; });
/* unused harmony export distance */
/* unused harmony export toRotate */
/**
 * @author gyb(mocheer)
 * @since 2017.7.10
 */
/**
 * 点在多边形
 */
var pointInPolygon = function pointInPolygon(p, arr) {
  var nCross = 0;
  if (arr.length > 0) {
    for (var i = 0; i < arr.length; i++) {
      var p0 = p,
          p1 = arr[i],
          p2 = arr[(i + 1) % arr.length];
      // 求解 y=p.y 与 p1p2 的交点
      if (p1.y == p2.y || p0.y < (p1.y <= p2.y ? p1.y : p2.y) || p0.y >= (p1.y >= p2.y ? p1.y : p2.y)) // p1p2 与 y=p0.y平行,交点在p1p2延长线上,交点在p1p2延长线上 
        continue;
      if ((p0.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x > p0.x) nCross++; //交点的X坐标大于p0的x坐标，只统计单边交点 			
    }
  }
  // 单边交点为偶数，点在多边形之外 --- 
  return nCross % 2 == 1;
};
/**
* 
* @param s start point
* @param p end point
*/
var distance = function distance(s, p) {
  return Math.sqrt((p[0] - s[0]) * (p[0] - s[0]) + (p[1] - s[1]) * (p[1] - s[1]));
};
/**
 * 
 * @param p 
 * @param angle 
 */
var toRotate = function toRotate(p, angle) {
  angle = Math.atan2(p.y, p.x) + angle;
  var r = Math.sqrt(p.x * p.x + p.y * p.y); //半径
  return {
    x: Math.cos(angle) * r,
    y: Math.sin(angle) * r
  };
};

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

/**
 * @see https://github.com/ProminentEdge/leaflet-measure-path
 */
!function () {

  L.Marker.Measurement = L.Layer.extend({
    options: {
      pane: 'markerPane'
    },

    initialize: function initialize(latlng, measurement, title, rotation, options) {
      L.setOptions(this, options);

      this._latlng = latlng;
      this._measurement = measurement;
      this._title = title;
      this._rotation = rotation;
    },

    addTo: function addTo(map) {
      map.addLayer(this);
      return this;
    },

    onAdd: function onAdd(map) {
      this._map = map;
      var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
      var el = this._element = L.DomUtil.create('div', 'leaflet-zoom-animated leaflet-measure-path-measurement', pane);
      var inner = L.DomUtil.create('div', '', el);
      inner.title = this._title;
      inner.innerHTML = this._measurement;

      map.on('zoomanim', this._animateZoom, this);

      this._setPosition();
    },

    onRemove: function onRemove(map) {
      map.off('zoomanim', this._animateZoom, this);
      var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
      pane.removeChild(this._element);
      this._map = null;
    },

    _setPosition: function _setPosition() {
      L.DomUtil.setPosition(this._element, this._map.latLngToLayerPoint(this._latlng));
      this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
    },

    _animateZoom: function _animateZoom(opt) {
      var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
      L.DomUtil.setPosition(this._element, pos);
      this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
    }
  });

  L.marker.measurement = function (latLng, measurement, title, rotation, options) {
    return new L.Marker.Measurement(latLng, measurement, title, rotation, options);
  };

  var formatDistance = function formatDistance(d) {
    var unit, feet;

    if (this._measurementOptions.imperial) {
      feet = d / 0.3048;
      if (feet > 3000) {
        d = d / 1609.344;
        unit = 'mi';
      } else {
        d = feet;
        unit = 'ft';
      }
    } else {
      if (d > 1000) {
        d = d / 1000;
        unit = 'km';
      } else {
        unit = 'm';
      }
    }

    if (d < 100) {
      return d.toFixed(1) + ' ' + unit;
    } else {
      return Math.round(d) + ' ' + unit;
    }
  };

  var formatArea = function formatArea(a) {
    var unit, sqfeet;

    if (this._measurementOptions.imperial) {
      if (a > 404.685642) {
        a = a / 4046.85642;
        unit = 'ac';
      } else {
        a = a / 0.09290304;
        unit = 'ft²';
      }
    } else {
      if (a > 1000000) {
        a = a / 1000000;
        unit = 'km²';
      } else {
        unit = 'm²';
      }
    }

    if (a < 100) {
      return a.toFixed(1) + ' ' + unit;
    } else {
      return Math.round(a) + ' ' + unit;
    }
  };

  var RADIUS = 6378137;
  // ringArea function copied from geojson-area
  // (https://github.com/mapbox/geojson-area)
  // This function is distributed under a separate license,
  // see LICENSE.md.
  var ringArea = function ringArea(coords) {
    var rad = function rad(_) {
      return _ * Math.PI / 180;
    };
    var p1,
        p2,
        p3,
        lowerIndex,
        middleIndex,
        upperIndex,
        area = 0,
        coordsLength = coords.length;

    if (coordsLength > 2) {
      for (var i = 0; i < coordsLength; i++) {
        if (i === coordsLength - 2) {
          // i = N-2
          lowerIndex = coordsLength - 2;
          middleIndex = coordsLength - 1;
          upperIndex = 0;
        } else if (i === coordsLength - 1) {
          // i = N-1
          lowerIndex = coordsLength - 1;
          middleIndex = 0;
          upperIndex = 1;
        } else {
          // i = 0 to N-3
          lowerIndex = i;
          middleIndex = i + 1;
          upperIndex = i + 2;
        }
        p1 = coords[lowerIndex];
        p2 = coords[middleIndex];
        p3 = coords[upperIndex];
        area += (rad(p3.lng) - rad(p1.lng)) * Math.sin(rad(p2.lat));
      }

      area = area * RADIUS * RADIUS / 2;
    }

    return Math.abs(area);
  };

  var circleArea = function circleArea(d) {
    var rho = d / RADIUS;
    return 2 * Math.PI * RADIUS * RADIUS * (1 - Math.cos(rho));
  };

  var override = function override(method, fn, hookAfter) {
    if (!hookAfter) {
      return function () {
        method.apply(this, arguments);
        return fn.apply(this, arguments);
      };
    } else {
      return function () {
        fn.apply(this, arguments);
        return method.apply(this, arguments);
      };
    }
  };

  L.Polyline.include({
    showMeasurements: function showMeasurements(options) {
      if (!this._map || this._measurementLayer) return this;

      this._measurementOptions = L.extend({
        showOnHover: false,
        minPixelDistance: 30,
        showDistances: true,
        showArea: true,
        lang: {
          totalLength: 'Total length',
          totalArea: 'Total area',
          segmentLength: 'Segment length'
        }
      }, options || {});

      this._measurementLayer = L.layerGroup().addTo(this._map);
      this.updateMeasurements();

      this._map.on('zoomend', this.updateMeasurements, this);

      return this;
    },

    hideMeasurements: function hideMeasurements() {
      this._map.off('zoomend', this.updateMeasurements, this);

      if (!this._measurementLayer) return this;
      this._map.removeLayer(this._measurementLayer);
      this._measurementLayer = null;

      return this;
    },

    onAdd: override(L.Polyline.prototype.onAdd, function () {
      if (this.options.showMeasurements) {
        this.showMeasurements(this.options.measurementOptions);
      }
    }),

    onRemove: override(L.Polyline.prototype.onRemove, function () {
      this.hideMeasurements();
    }, true),

    setLatLngs: override(L.Polyline.prototype.setLatLngs, function () {
      return this.updateMeasurements();
    }),

    spliceLatLngs: override(L.Polyline.prototype.spliceLatLngs, function () {
      return this.updateMeasurements();
    }),

    formatDistance: formatDistance,
    formatArea: formatArea,

    updateMeasurements: function updateMeasurements() {
      if (!this._measurementLayer) return this;

      var latLngs = this.getLatLngs(),
          isPolygon = this instanceof L.Polygon,
          options = this._measurementOptions,
          totalDist = 0,
          formatter,
          ll1,
          ll2,
          p1,
          p2,
          pixelDist,
          dist;

      if (latLngs && latLngs.length && L.Util.isArray(latLngs[0])) {
        // Outer ring is stored as an array in the first element,
        // use that instead.
        latLngs = latLngs[0];
      }

      this._measurementLayer.clearLayers();

      if (this._measurementOptions.showDistances && latLngs.length > 1) {
        formatter = this._measurementOptions.formatDistance || L.bind(this.formatDistance, this);

        for (var i = 1, len = latLngs.length; isPolygon && i <= len || i < len; i++) {
          ll1 = latLngs[i - 1];
          ll2 = latLngs[i % len];
          dist = ll1.distanceTo(ll2);
          totalDist += dist;

          p1 = this._map.latLngToLayerPoint(ll1);
          p2 = this._map.latLngToLayerPoint(ll2);

          pixelDist = p1.distanceTo(p2);

          if (pixelDist >= options.minPixelDistance) {
            L.marker.measurement(this._map.layerPointToLatLng([(p1.x + p2.x) / 2, (p1.y + p2.y) / 2]), formatter(dist), options.lang.segmentLength, this._getRotation(ll1, ll2), options).addTo(this._measurementLayer);
          }
        }

        // Show total length for polylines
        if (!isPolygon) {
          L.marker.measurement(ll2, formatter(totalDist), options.lang.totalLength, 0, options).addTo(this._measurementLayer);
        }
      }

      if (isPolygon && options.showArea && latLngs.length > 2) {
        formatter = options.formatArea || L.bind(this.formatArea, this);
        var area = ringArea(latLngs);
        L.marker.measurement(this.getBounds().getCenter(), formatter(area), options.lang.totalArea, 0, options).addTo(this._measurementLayer);
      }

      return this;
    },

    _getRotation: function _getRotation(ll1, ll2) {
      var p1 = this._map.project(ll1),
          p2 = this._map.project(ll2);

      return Math.atan((p2.y - p1.y) / (p2.x - p1.x));
    }
  });

  L.Polyline.addInitHook(function () {
    if (this.options.showMeasurements) {
      this.showMeasurements();
    }
  });

  L.Circle.include({
    showMeasurements: function showMeasurements(options) {
      if (!this._map || this._measurementLayer) return this;

      this._measurementOptions = L.extend({
        showOnHover: false,
        showArea: true,
        lang: {
          totalArea: 'Total area'
        }
      }, options || {});

      this._measurementLayer = L.layerGroup().addTo(this._map);
      this.updateMeasurements();

      this._map.on('zoomend', this.updateMeasurements, this);

      return this;
    },

    hideMeasurements: function hideMeasurements() {
      this._map.on('zoomend', this.updateMeasurements, this);

      if (!this._measurementLayer) return this;
      this._map.removeLayer(this._measurementLayer);
      this._measurementLayer = null;

      return this;
    },

    onAdd: override(L.Circle.prototype.onAdd, function () {
      if (this.options.showMeasurements) {
        this.showMeasurements(this.options.measurementOptions);
      }
    }),

    onRemove: override(L.Circle.prototype.onRemove, function () {
      this.hideMeasurements();
    }, true),

    setLatLng: override(L.Circle.prototype.setLatLng, function () {
      this.updateMeasurements();
    }),

    setRadius: override(L.Circle.prototype.setRadius, function () {
      this.updateMeasurements();
    }),

    formatArea: formatArea,

    updateMeasurements: function updateMeasurements() {
      if (!this._measurementLayer) return;

      var latLng = this.getLatLng(),
          options = this._measurementOptions,
          formatter = options.formatArea || L.bind(this.formatArea, this);

      this._measurementLayer.clearLayers();

      if (options.showArea) {
        formatter = options.formatArea || L.bind(this.formatArea, this);
        var area = circleArea(this.getRadius());
        L.marker.measurement(latLng, formatter(area), options.lang.totalArea, 0, options).addTo(this._measurementLayer);
      }
    }
  });

  L.Circle.addInitHook(function () {
    if (this.options.showMeasurements) {
      this.showMeasurements();
    }
  });
}();

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(168);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(7).default
var update = add("10279068", content, true, {});

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)(false);
// imports


// module
exports.push([module.i, ".leaflet-measure-path-measurement{position:absolute;font-size:10px;color:#000;text-shadow:-1px 0 0 #fff,-1px -1px 0 #fff,0 -1px 0 #fff,1px -1px 0 #fff,1px 0 0 #fff,1px 1px 0 #fff,0 1px 0 #fff,-1px 1px 0 #fff;white-space:nowrap;transform-origin:0;pointer-events:none}.leaflet-measure-path-measurement>div{position:relative;margin-top:-25%;left:-50%}", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// drawLayer.js